import CartProduct from './CartProduct'

export default CartProduct
